const API_BASE_URL = process.env.REACT_APP_API_URL;
const API_KEY = process.env.REACT_APP_API_KEY;
const API_NOMINATIM_URL = process.env.REACT_APP_NOMINATIM_URL;
const NOMINATIM_API_KEY = process.env.REACT_APP_NOMINATIM_API_KEY;

export const getApiConfig = () => ({
    baseURL: API_BASE_URL,
    nominatimURL: API_NOMINATIM_URL,
    headers: {
        "Content-Type": "application/json; charset=utf-8",
        "x-api-key": API_KEY
    },
    nominatimHeaders: {
         "Content-Type": "application/json; charset=utf-8",
        "x-api-key": NOMINATIM_API_KEY
    }
});
